import './infiniteslidev2';

// Logo scrolling
(($) => {
  $(document).ready(function(){
    $('[data-logo-carousel] .logos').infiniteslide({
      speed: 50,
      direction: 'left',
      pauseonhover: false,
      responsive: true,
      clone: 2
    });
  });
})(jQuery);